import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import applicationSelectors from 'frontend/redux/selectors/application-selectors'
import { bindActionCreators } from 'redux'
import { getGeoData } from 'frontend/redux/actions/application-actions'
import ConsultasClient from '../../../api/consultas'
import './formulario-reclamo.css'

class FormularioReclamo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      agenciaId: this.props.application.applicationId,
      nombreAgencia: this.props.application.nombre,
      emailAgencia: this.props.application.templateData.header.emailContacto,
      paisId: this.props.application.paisId,
      estado: {
        id: 1,
      },
      tipoDocumento: 'DNI',
      numeroDocumento: '',
      nombre: '',
      apellidoMaterno: '',
      apellidoPaterno: '',
      domicilio: '',
      departamento: '',
      provincia: '',
      distrito: '',
      telefonoFijo: '',
      telefonoCelular: '',
      email: '',
      bienContratado: 'Producto',
      monto: '',
      comentarios: '',
      tipoReclamo: 'Reclamo',
      detalleReclamo: '',
      pedido: '',
      menorEdad: '',
      tipoDocumentoApoderado: '',
      documentoApoderado: '',
      nombreApoderado: '',
      apellidoMaternoApoderado: '',
      apellidoPaternoApoderado: '',
      telefonoFijoApoderado: '',
      telefonoCelularApoderado: '',
      emailApoderado: '',
      estadoConsulta: 'creando',
    }
    this.setearEstado = this.setearEstado.bind(this)
    this.enviarConsulta = this.enviarConsulta.bind(this)
    this.armarRequestConsulta = this.armarRequestConsulta.bind(this)
  }

  setearEstado(event) {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  armarRequestConsulta() {
    return {
      agenciaId: this.state.agenciaId,
      nombreAgencia: this.state.nombreAgencia,
      emailAgencia: this.state.emailAgencia,
      paisId: this.state.paisId,
      estado: this.state.estado,
      tipoDocumento: this.state.tipoDocumento,
      numeroDocumento: this.state.numeroDocumento,
      nombre: this.state.nombre,
      apellidoMaterno: this.state.apellidoMaterno,
      apellidoPaterno: this.state.apellidoPaterno,
      domicilio: this.state.domicilio,
      departamento: this.state.departamento,
      provincia: this.state.provincia,
      distrito: this.state.distrito,
      telefonoFijo: this.state.telefonoFijo,
      telefonoCelular: this.state.telefonoCelular,
      email: this.state.email,
      bienContratado: this.state.bienContratado,
      monto: this.state.monto,
      comentarios: this.state.comentarios,
      tipoReclamo: this.state.tipoReclamo,
      detalleReclamo: this.state.detalleReclamo,
      pedido: this.state.pedido,
      menorEdad: this.state.menorEdad,
      tipoDocumentoApoderado: this.state.tipoDocumentoApoderado,
      documentoApoderado: this.state.documentoApoderado,
      nombreApoderado: this.state.nombreApoderado,
      apellidoMaternoApoderado: this.state.apellidoMaternoApoderado,
      apellidoPaternoApoderado: this.state.apellidoPaternoApoderado,
      telefonoFijoApoderado: this.state.telefonoFijoApoderado,
      telefonoCelularApoderado: this.state.telefonoCelularApoderado,
      emailApoderado: this.state.emailApoderado,
      estadoConsulta: 'creando',
    }
  }

  enviarConsulta(event) {
    event.preventDefault()
    const { token } = this.props.application
    let data = this.armarRequestConsulta()
    this.setState({ estadoConsulta: 'enviando' })
    ConsultasClient.reclamoMarcaBlanca(data, token).then((res) => {
      if (res.status === 201) {
        this.setState({
          estadoConsulta: 'enviado',
        })
        ConsultasClient.enviarMailReclamo(data, token).then((res) => {
          if (res.status === 201) {
            console.log('Email Sent')
          } else {
            console.error('EMAIL - Error')
          }
        })
      } else {
        this.setState({
          estadoConsulta: 'error',
        })
      }
    })
  }

  render() {
    const { t } = this.props

    const formulario = (
      <div className='container-consult'>
        <div className='form-consult panel panel-default custom consulta'>
          <form onSubmit={this.enviarConsulta}>
            <h2 className='text-xl font-bold consulta-title c mb-8'>{t('requestForm.claims')}</h2>
            <h3 className='text-lg font-bold consulta-title c mb-6'>{t('requestForm.claimsData')}</h3>

            <div className='grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6'>
              <div className='form-group'>
                <label htmlFor='tipoDocumento' className='block text-gray-700 text-sm font-bold mb-3'>
                  {t('checkout.idType')}(*)
                </label>
                <select
                  id='tipoDocumento'
                  onChange={this.setearEstado}
                  value={this.state.tipoDocumento}
                  name='tipoDocumento'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full'
                  required
                >
                  <option key='DNI' value='DNI'>
                    DNI
                  </option>
                  <option key='C.E.' value='C.E.'>
                    C.E.
                  </option>
                </select>
              </div>

              <div className='form-group'>
                <span className='block text-gray-700 text-sm font-bold mb-2'>{t('checkout.document')}(*)</span>
                <input
                  id='numeroDocumento'
                  onChange={this.setearEstado}
                  value={this.state.numeroDocumento}
                  name='numeroDocumento'
                  type='number'
                  className='shadow appearance-none2 border rounded py-2 px-3 text-gray-700 leading-tight w-full mt-1'
                  required
                />
              </div>
              <div className='form-group'>
                <span className='block text-gray-700 text-sm font-bold mb-2'>{t('checkout.name')}s(*)</span>
                <input
                  id='nombre'
                  onChange={this.setearEstado}
                  value={this.state.nombre}
                  name='nombre'
                  type='text'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full mt-1'
                  required
                />
              </div>
            </div>

            <div className='grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6'>
              <div className='form-group'>
                <span className='block text-gray-700 text-sm font-bold mb-2'>
                  {t('requestForm.lastName')} {t('requestForm.paternal')}
                </span>
                <input
                  id='apellidoPaterno'
                  onChange={this.setearEstado}
                  value={this.state.apellidoPaterno}
                  name='apellidoPaterno'
                  type='text'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full mt-1'
                />
              </div>
              <div className='form-group'>
                <span className='block text-gray-700 text-sm font-bold mb-2'>
                  {t('requestForm.lastName')} {t('requestForm.maternal')}
                </span>
                <input
                  id='apellidoMaterno'
                  onChange={this.setearEstado}
                  value={this.state.apellidoMaterno}
                  name='apellidoMaterno'
                  type='text'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full mt-1'
                />
              </div>
              <div className='form-group'>
                <span className='block text-gray-700 text-sm font-bold mb-2'>{t('requestForm.location')}(*)</span>
                <input
                  id='domicilio'
                  onChange={this.setearEstado}
                  value={this.state.domicilio}
                  name='domicilio'
                  type='text'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full mt-1'
                  required
                />
              </div>
            </div>

            <div className='grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6'>
              <div className='form-group'>
                <span className='block text-gray-700 text-sm font-bold mb-2'>{t('requestForm.department')}</span>
                <input
                  id='departamento'
                  onChange={this.setearEstado}
                  value={this.state.departamento}
                  name='departamento'
                  type='text'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full mt-1'
                />
              </div>
              <div className='form-group'>
                <span className='block text-gray-700 text-sm font-bold mb-2'>{t('checkout.province')}</span>
                <input
                  id='provincia'
                  onChange={this.setearEstado}
                  value={this.state.provincia}
                  name='provincia'
                  type='text'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full mt-1'
                />
              </div>
              <div className='form-group'>
                <span className='block text-gray-700 text-sm font-bold mb-2'>{t('requestForm.district')}</span>
                <input
                  id='distrito'
                  onChange={this.setearEstado}
                  value={this.state.distrito}
                  name='distrito'
                  type='text'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full mt-1'
                />
              </div>
            </div>

            <div className='grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6'>
              <div className='form-group'>
                <span className='block text-gray-700 text-sm font-bold mb-2'>{t('checkout.localPhone')}</span>
                <input
                  id='telefonoFijo'
                  onChange={this.setearEstado}
                  value={this.state.telefonoFijo}
                  name='telefonoFijo'
                  type='number'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full mt-1'
                />
              </div>
              <div className='form-group'>
                <span className='block text-gray-700 text-sm font-bold mb-2'>{t('checkout.cellphone')}(*)</span>
                <input
                  id='telefonoCelular'
                  onChange={this.setearEstado}
                  value={this.state.telefonoCelular}
                  name='telefonoCelular'
                  type='number'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full mt-1'
                  required
                />
              </div>
              <div className='form-group'>
                <span className='block text-gray-700 text-sm font-bold mb-2'>E-mail(*)</span>
                <input
                  id='email'
                  onChange={this.setearEstado}
                  value={this.state.email}
                  name='email'
                  type='email'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full mt-1'
                  required
                />
              </div>
            </div>

            <h3 className='font-bold text-lg consulta-title c mb-6'>{t('requestForm.generalInfo')}</h3>

            <div className='grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6'>
              <div className='form-group'>
                <label htmlFor='bienContratado' className='block text-gray-700 text-sm font-bold mb-3'>
                  {t('requestForm.goods')}
                </label>
                <div className='form-radio'>
                  <label className='form-radio'>
                    <input
                      type='radio'
                      value='Producto'
                      checked={this.state.bienContratado === 'Producto'}
                      onChange={(e) =>
                        this.setState({
                          bienContratado: e.target.value,
                        })
                      }
                    />
                    Producto
                  </label>
                  <label className='form-radio'>
                    <input
                      type='radio'
                      value='Servicio'
                      checked={this.state.bienContratado === 'Servicio'}
                      onChange={(e) =>
                        this.setState({
                          bienContratado: e.target.value,
                        })
                      }
                    />
                    Servicio
                  </label>
                </div>
              </div>

              <div className='form-group'>
                <span className='block text-gray-700 text-sm font-bold mb-2'>{t('requestForm.amount')} (en S/.)</span>
                <input
                  id='monto'
                  onChange={this.setearEstado}
                  value={this.state.monto}
                  name='monto'
                  type='number'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full mt-1'
                />
              </div>
            </div>

            <div className='grid grid-cols-1 gap-4 mb-6'>
              <div className='form-group'>
                <label className='block text-gray-700 text-sm font-bold mb-2' htmlFor='comentarios'>
                  {t('layout:packages.details.description')}(*)
                </label>
                <textarea
                  id='comentarios'
                  onChange={this.setearEstado}
                  value={this.state.comentarios}
                  name='comentarios'
                  className='h-36 shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full'
                  rows='6'
                  required
                />
              </div>
            </div>

            <h3 className='font-bold text-lg consulta-title c mb-6'>{t('requestForm.detail')}</h3>

            <div className='form-group mb-6'>
              <label htmlFor='tipoReclamo' className='block text-gray-700 text-sm font-bold mb-3'>
                Tipo
              </label>
              <div className='form-radio'>
                <label className='form-radio'>
                  <input
                    type='radio'
                    value='Reclamo'
                    checked={this.state.tipoReclamo === 'Reclamo'}
                    onChange={(e) =>
                      this.setState({
                        tipoReclamo: e.target.value,
                      })
                    }
                  />
                  Reclamo
                </label>
                <label className='form-radio'>
                  <input
                    type='radio'
                    value='Queja'
                    checked={this.state.tipoReclamo === 'Queja'}
                    onChange={(e) =>
                      this.setState({
                        tipoReclamo: e.target.value,
                      })
                    }
                  />
                  Queja
                </label>
              </div>
            </div>

            <div className='grid grid-cols-1 gap-4 mb-6'>
              <div className='form-group'>
                <label className='block text-gray-700 text-sm font-bold mb-2' htmlFor='detalleReclamo'>
                  {t('requestForm.detailClaim')}(*)
                </label>
                <textarea
                  id='detalleReclamo'
                  onChange={this.setearEstado}
                  value={this.state.detalleReclamo}
                  name='detalleReclamo'
                  className='h-36 shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full'
                  rows='6'
                  required
                />
              </div>
            </div>

            <div className='grid grid-cols-1 gap-4 mb-6'>
              <div className='form-group'>
                <label className='block text-gray-700 text-sm font-bold mb-2' htmlFor='pedido'>
                  {t('requestForm.claimType')}
                </label>
                <textarea
                  id='pedido'
                  onChange={this.setearEstado}
                  value={this.state.pedido}
                  name='pedido'
                  className='h-36 shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full'
                  rows='6'
                />
              </div>
            </div>

            <h3 className='font-bold text-lg consulta-title c mb-6'>{t('requestForm.ownerData')}</h3>

            <div className='grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6'>
              <div className='form-group'>
                <label htmlFor='menorEdad' className='block text-gray-700 text-sm font-bold mb-3'>
                  {t('requestForm.underAge')}
                </label>
                <select
                  id='menorEdad'
                  onChange={this.setearEstado}
                  value={this.state.menorEdad}
                  name='menorEdad'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full'
                >
                  <option key='---' value=''>
                    ---
                  </option>
                  <option key='SI' value='SI'>
                    SI
                  </option>
                  <option key='NO' value='NO'>
                    NO
                  </option>
                </select>
              </div>

              <div className='form-group'>
                <label htmlFor='tipoDocumentoApoderado' className='block text-gray-700 text-sm font-bold mb-3'>
                  {t('checkout.idType')} {t('checkout.owner')}
                </label>
                <select
                  id='tipoDocumentoApoderado'
                  onChange={this.setearEstado}
                  value={this.state.tipoDocumentoApoderado}
                  name='tipoDocumentoApoderado'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full'
                >
                  <option key='---' value=''>
                    ---
                  </option>
                  <option key='DNI' value='DNI'>
                    DNI
                  </option>
                  <option key='C.E.' value='C.E.'>
                    C.E.
                  </option>
                </select>
              </div>

              <div className='form-group'>
                <span className='block text-gray-700 text-sm font-bold mb-2'>
                  {t('checkout.document')} {t('checkout.owner')}
                </span>
                <input
                  id='documentoApoderado'
                  onChange={this.setearEstado}
                  value={this.state.documentoApoderado}
                  name='documentoApoderado'
                  type='number'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full mt-1'
                />
              </div>
            </div>

            <div className='grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6'>
              <div className='form-group'>
                <span className='block text-gray-700 text-sm font-bold mb-2'>{t('checkout.name')}s</span>
                <input
                  id='nombreApoderado'
                  onChange={this.setearEstado}
                  value={this.state.nombreApoderado}
                  name='nombreApoderado'
                  type='text'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full mt-1'
                />
              </div>
              <div className='form-group'>
                <span className='block text-gray-700 text-sm font-bold mb-2'>
                  {t('requestForm.lastName')} {t('requestForm.paternal')}
                </span>
                <input
                  id='apellidoPaternoApoderado'
                  onChange={this.setearEstado}
                  value={this.state.apellidoPaternoApoderado}
                  name='apellidoPaternoApoderado'
                  type='text'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full mt-1'
                />
              </div>
              <div className='form-group'>
                <span className='block text-gray-700 text-sm font-bold mb-2'>
                  {t('requestForm.lastName')} {t('requestForm.maternal')}
                </span>
                <input
                  id='apellidoMaternoApoderado'
                  onChange={this.setearEstado}
                  value={this.state.apellidoMaternoApoderado}
                  name='apellidoMaternoApoderado'
                  type='text'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full mt-1'
                />
              </div>
            </div>

            <div className='grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6'>
              <div className='form-group'>
                <span className='block text-gray-700 text-sm font-bold mb-2'>{t('checkout.localPhone')}</span>
                <input
                  id='telefonoFijoApoderado'
                  onChange={this.setearEstado}
                  value={this.state.telefonoFijoApoderado}
                  name='telefonoFijoApoderado'
                  type='number'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full mt-1'
                />
              </div>
              <div className='form-group'>
                <span className='block text-gray-700 text-sm font-bold mb-2'>{t('checkout.cellphone')}</span>
                <input
                  id='telefonoCelularApoderado'
                  onChange={this.setearEstado}
                  value={this.state.telefonoCelularApoderado}
                  name='telefonoCelularApoderado'
                  type='number'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full mt-1'
                />
              </div>
              <div className='form-group'>
                <span className='block text-gray-700 text-sm font-bold mb-2'>E-mail</span>
                <input
                  id='emailApoderado'
                  onChange={this.setearEstado}
                  value={this.state.emailApoderado}
                  name='emailApoderado'
                  type='email'
                  className='shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full mt-1'
                />
              </div>
            </div>

            <div className='flex'>
              <button type='submit' className='ml-auto border border-blue-200 consulta-title transition duration-300 hover:bg-blue-100 font-semibold py-2 px-8 rounded focus:outline-none'>
                {t('requestForm.send')}
              </button>
            </div>
          </form>
        </div>
      </div>
    )
    switch (this.state.estadoConsulta) {
      case 'creando':
        return formulario
      case 'enviando':
        return <div className='panel panel-default consulta-enviada mb-5 bg-white'>{t('requestForm.sending')} ...</div>
      case 'enviado':
        return <div className='panel panel-default consulta-enviada mb-5 bg-white'>{t('requestForm.confirm')}</div>
      case 'error':
        return <div className='panel panel-default consulta-error mb-5 bg-white'>{t('requestForm.error')}</div>
      default:
        return formulario
    }
  }
}

const mapStateToProps = (state) => ({
  application: state.applicationState,
  paisId: state.applicationState.paisId,
  applicationType: parseInt(state.applicationState.tipoAplicacionId),
  provinces: applicationSelectors.cities(state),
  localities: applicationSelectors.localities(state),
})

const mapDispatchToProps = function(dispatch) {
  return {
    actions: bindActionCreators({ getGeoData }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(['translations'])(FormularioReclamo))
